<template>
  <ion-page>
    <ion-content>
      <div class="wrap">
        <div class="login-form">
          <div class="form-header">
            <img src="../assets/model_space_logo.png" alt="Model Space" />
            <p>Enter your email below and we'll send you instructions to recover your passwords.</p>
          </div>

          <!--Email Input-->
          <div class="form-group">
            <ion-item>
              <ion-label position="stacked">Email</ion-label>
              <ion-input
                @ionChange="(_event)=> email = _event.detail.value"
                type="email"
                placeholder="email@account.com"
                clearInput
                clear-input="true"
                required="true"
              ></ion-input>
            </ion-item>
          </div>

          <!--Login Button-->
          <div class="form-group">
            <ion-button @click="recover" expand="full">Recover</ion-button>
          </div>

          <div class="form-footer">
            <ion-router-link href="/login" color="secondary">Return to login</ion-router-link>
          </div>

          <error-message v-if="error" v-bind:message="error"></error-message>
        </div>
        <!-- /.login-form -->
      </div>
      <!-- /.wrap -->
    </ion-content>
  </ion-page>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Recover",
  data: function() {
    return {
      email: "",
      error: false
    };
  },

  methods: {
    recover: function(e) {
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.showToast("Password reset email sent.");
          this.email = "";
        })
        .catch(error => {
          this.error = error.message;
        });
      e.preventDefault();
    },

    async showToast(message) {
      const toast = await this.$ionic.toastController.create({
        message: message,
        showCloseButton: true,
        position: "bottom",
        closeButtonText: "Done",
        duration: 2000
      });
      return await toast.present();
    }
  }
};
</script>

<style scoped>
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--ion-color-primary);
}

.login-form {
  width: 350px;
  margin: 0 auto;
  border: 1px solid #ddd;
  padding: 2rem;
  background: #ffffff;
}

.form-input {
  background: #fafafa;
  border: 1px solid #eeeeee;
  padding: 12px;
  width: 100%;
}

.form-group {
  margin-bottom: 1rem;
}

.form-button {
  background: #69d2e7;
  border: 1px solid #ddd;
  color: #ffffff;
  padding: 10px;
  width: 100%;
  text-transform: uppercase;
}

.form-button:hover {
  background: #69c8e7;
}

.form-header {
  text-align: center;
  margin-bottom: 2rem;
}

.form-footer {
  padding-top: 16px;
  text-align: center;
}
</style>